import { Controller } from "@hotwired/stimulus"

// SMS compose controller — character/segment counter
// Connects to data-controller="sms-compose"
export default class extends Controller {
  static targets = ["input", "counter", "segments"]

  connect() {
    this.count()
  }

  count() {
    const text = this.inputTarget.value || ""
    const chars = text.length
    const segments = chars <= 160 ? 1 : Math.ceil(chars / 153)

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${chars} character${chars !== 1 ? "s" : ""}`
      this.counterTarget.classList.toggle("text-red-500", chars > 1600)
    }

    if (this.hasSegmentsTarget) {
      this.segmentsTarget.textContent = `${segments} segment${segments !== 1 ? "s" : ""}`
      this.segmentsTarget.classList.toggle("text-yellow-600", segments > 1)
    }
  }
}
